/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import {
  CheckCircleIcon,
  colors,
  WarningIcon
} from "@dotnet/telematics-design-system";

import { FILE_UPLOAD_STATUS } from "../../../shared";
import Tooltip from "../../Tooltip/Tooltip";
import { StatusIconProps } from "../types";
import { useStyles } from "./styles";

const StatusIcon = ({ uploadStatus }: StatusIconProps) => {
  const { t } = useTranslation();

  const { statusIconCSS } = useStyles();

  const isSuccess = uploadStatus === FILE_UPLOAD_STATUS.Success;

  return (
    <Tooltip
      placement="top"
      title={
        isSuccess
          ? t("Dropzone##file successfully uploaded")
          : t("Dropzone##error uploading the file")
      }
    >
      <span css={css(statusIconCSS)}>
        {isSuccess ? (
          <CheckCircleIcon color={colors.green600} />
        ) : (
          <WarningIcon color={colors.orange600} />
        )}
      </span>
    </Tooltip>
  );
};

export default StatusIcon;
